import i18next from 'i18next'
import _ from 'lodash'
import moment from 'moment'
import { QuantityDto } from '../services/APIs/InternalAPI/internal-api.contracts'

export function QuantityParser(
  str: string,
  selectableAbbreviations?: string[]
): QuantityDto {
  const parsed = str.match(/(-?\d*\.?\,?\d+)\s?([a-z%]+)/)
  return {
    value: parseFloat(parsed[1]),
    unit:
      parsed[2] ??
      (selectableAbbreviations && selectableAbbreviations[0]) ??
      '',
    selectableAbbreviations: selectableAbbreviations || ['m', 'cm', 'mm'],
  }
}

export function QuantityIsValid(quantity: QuantityDto) {
  if (!quantity) return false

  return quantity.unit && quantity.value >= 0
}

const formatFn = (value: number, padStart = 2) =>
  value.toString().padStart(padStart, '0')

export function QuantityString(quantity: QuantityDto, showValue1 = true) {
  if (!quantity || isNaN(quantity.value)) return ''

  // const value = quantity.value;
  const value = new Intl.NumberFormat(i18next.language, {
    maximumFractionDigits: 2,
    minimumFractionDigits: (quantity.value * 100) % 10 === 0 ? 0 : 2,
  }).format(quantity.value)

  return showValue1
    ? `${value} ${quantity.unit}`
    : quantity.value === 1
    ? `${quantity.unit}`
    : `${value} ${quantity.unit}`
}

export function RoundedQuantityString(quantity: QuantityDto) {
  if (!quantity) return ''

  const roundedQuantity = { ...quantity }
  roundedQuantity.value = parseInt(
    parseFloat(quantity.value?.toString() || '0')?.toFixed(0)
  )
  return QuantityString(roundedQuantity)
  // return `${numeral(quantity.value).format('0,0')} ${quantity.unit}`
}

export function TimeString(quantity: QuantityDto) {
  if (!quantity || quantity.value == null) return ''

  let durationUnit: 'h' | 'm' | 's' | 'ms'

  switch (quantity.unit) {
    case 'hrs': {
      durationUnit = 'h'
      break
    }
    case 'min': {
      durationUnit = 'm'
      break
    }
    case 'sec': {
      durationUnit = 's'
      break
    }
  }

  const duration = moment.duration(quantity.value || 0, durationUnit)

  const m = moment.utc(duration.asMilliseconds())

  return `${formatFn(Math.floor(duration.asHours()))}h ${formatFn(
    m.minute()
  )}m ${formatFn(Math.round(m.second()))}s`
}

export const SumQuantity = ([...args]: QuantityDto[]) => {
  const sum = _.sumBy(args, (x) => x.value)

  return {
    ...args[0],
    value: sum,
  }
}

export const MultiplyQuantity = (
  quantity: QuantityDto,
  multiplicant: number
) => {
  if (!quantity) return null

  const value = quantity.value * multiplicant

  const newQuantity = { ...quantity, value }

  return newQuantity
}
